import { useEffect, useRef } from 'react';
import './App.css';

function App() {
  const starsRef = useRef(null);

  useEffect(() => {
    const container = starsRef.current;
    if (!container) return;
    for (let i = 0; i < 70; i++) {
      const s = document.createElement('div');
      s.className = 'star';
      const size = Math.random() * 1.8 + 0.4;
      s.style.cssText = [
        `width: ${size}px`,
        `height: ${size}px`,
        `left: ${Math.random() * 100}%`,
        `top: ${Math.random() * 55}%`,
        `opacity: ${(Math.random() * 0.45 + 0.08).toFixed(2)}`,
      ].join('; ');
      container.appendChild(s);
    }
  }, []);

  return (
    <div className="page">
      <div className="stars" ref={starsRef} />

      {/* Nav */}
      <nav className="nav">
        <span className="logo">Migrate3000</span>
      </nav>

      {/* Main */}
      <main className="main">
        <div className="centre">
          <div className="eyebrow">
            <span className="pulse-dot" />
            <span className="eyebrow-text">Launching 2026</span>
          </div>
          <h1 className="headline">Something is coming.</h1>
          <p className="subline">We could tell you what this is. But where's the fun in that.</p>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <span className="footer-copy">© 2026 Migrate3000 Ltd</span>
        <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
        </div>
      </footer>
    </div>
  );
}

export default App;
